import { render } from "./Index.vue?vue&type=template&id=0fa5b171&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0fa5b171&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa5b171"]])

export default __exports__